import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomBolderCross({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2.77 2.926a.744.744 0 00.073.968l6.105 6.105-6.105 6.107a.744.744 0 00.526 1.269l.115-.01a.745.745 0 00.41-.206L10 11.052l6.105 6.106a.742.742 0 001.051 0l.072-.083a.744.744 0 00-.07-.969L11.05 10l6.105-6.105a.744.744 0 000-1.051l-.083-.072a.744.744 0 00-.968.072L9.999 8.948 3.894 2.843a.744.744 0 00-1.051 0l-.072.083z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
export default SvgIconCustomBolderCross;
